export default __webpack_public_path__ + "static/media/home-logo.7dedcd99.png";